import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation } from 'react-router-dom';
import { FaStar } from "react-icons/fa";
import { BiImageAdd } from 'react-icons/bi';
import { MdEdit } from "react-icons/md";
import { Box, Button, styled, Dialog, DialogTitle, DialogActions, IconButton, TextField, FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, OutlinedInput, Autocomplete } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import userPic from "../../images/userimg.jpeg";
import { CandidateProAction } from "../../Redux/action/CandidateProAction";
import { CandidateProfile } from "../../Redux/action/CandidateProfileAction";
import { CandidateUpdateProImg } from "../../Redux/action/CandidateUpdateProImgAction";
import { toast, ToastContainer } from 'react-toastify';
import ProfileDropdown from './ProfileDropdown';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { CandidateProAction2 } from '../../Redux/action/CandidateProAction2';
import countryList from '../../Countries';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

const CandidatePro = (props) => {
    const { userResult } = useSelector((state) => state.Auth);
    const [open, setOpen] = useState(false);
    const [image, setImage] = useState({ preview: "", raw: "" });
    const [profileImg, setProfileImg] = useState("")
    const [initProfileImg, setInitProfileImg] = useState("");
    const [file, setFile] = useState(null);
    const [panCardFile, setPanCardFile] = useState(null);
    const [isPassport, setIsPassport] = useState(false);
    const [isTravelledAbroad, setIsTravelledAbroad] = useState(false);
    const [travelledCountries, setTravelledCountries] = useState(['America','England']);

    const [customCandidateInfo,setCustomCandidateInfo] = useState({
        isPassport: "",
        isTravelledAbroad: "",
        travelledCountries: [],
    })

    const [data, setData] = useState({
        firstName: "",
        lastName: "",
        currentDesignation: "",
        skillList: [],
    });


    const fileInputRef = useRef();
    const dispatch = useDispatch();

    const id = props.data

    const {
        firstName,
        lastName,
        currentDesignation,
        skillList
    } = data;

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    console.log("FILE--", file)

    const userInfo = useSelector((state) => state?.Profile?.result);
    const userProfileImg = useSelector((state) => state.ProfileImg?.data?.profileImageUrl);
    const ProfileImgData = useSelector((state) => state.ProfileImg.data)
    const profileData = useSelector((state) => state.ProfileUpdateData?.data?.data);

    let newdata = []

    // if (userInfo.skills) {
    //     const newuser = userInfo.skills.split(",");
    //     newdata.push(newuser)
    //     // console.log(newuser, "userInfoProfffff");
    // } else {
    //     console.log("userInfoProfffff");
    // }
    //  const newuser = userInfo.skills.split(",")

    let userData = userInfo;
    let updatedSkills = []

    useEffect(() => {
        dispatch(CandidateProfile(id));
    }, [ProfileImgData])

    // if (skills) {
    //     const newuser = skills?.split(",")
    //     updatedSkills.push(newuser)
    //     // console.log(newuser, "userInfoProfffff")
    // } else {
    //     // console.log("userInfoProfffff")
    // }

    useEffect(() => {
        if (userData) {
            setData({ ...userData });
        }
    }, [userData]);

    useEffect(() => {
        if (profileData) {
            setData({ ...profileData });
        }
        else if (userData) {
            setData({ ...userData });
        }
    }, [profileData, dispatch, userData]);

    useEffect(() => {
        if (userProfileImg) {
            setProfileImg(userProfileImg);
        }
        else if (userInfo?.profileImageUrl) {
            setProfileImg(userInfo?.profileImageUrl);
        }
    }, [userProfileImg, dispatch, userInfo?.profileImageUrl]);

    const handleInputChange = (e) => {
        let { name, value } = e.target;
        if (name === "skillList") {
            // Split the comma-separated string into an array
            value = value.split(",").map((skillList) => skillList.trim());
        }
        setData({ ...data, [name]: value });
    };

    const candidateId = userResult?.userid;;

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Create a new FormData object
        let formData = new FormData();
    
        // Append text data to the FormData object
        formData.append("candidateReqDto", JSON.stringify({
            candidateId,
            firstName,
            lastName,
            currentDesignation,
            skillList,

            customCandidateInfo: {
                travelledCountries,
                isTravelledAbroad,
                isPassport,
            }
        }));

        if (file) {
            formData.append("aadhaarCard", file);
        }
    
        if (panCardFile) {
            formData.append("panCard", panCardFile);
        }
    
        // Dispatch the action with the FormData object
        dispatch(CandidateProAction2(formData));
    };

    const handleCountries = (event) => {
        const {
            target: { value },
        } = event;
        setTravelledCountries(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const handleCountryChange = (event, value) => {
        setTravelledCountries(value);
    };

    console.log('COUNTRIES--->', travelledCountries)
    
    const location = useLocation();

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const fileChange = (e) => {
        const file = e.target.files[0]
        // console.log('file---', file)
        if (file) {
            const fileSizeInBytes = file.size;
            const maxSizeInBytes = 1024 * 1024; // 1MB
            if (fileSizeInBytes > maxSizeInBytes) {
                toast.error('File size exceeds 1MB. Please select a smaller file.');
                e.target.value = null;
            }
            else {
                // File size is within the limit, you can proceed with the upload
                setImage({
                    preview: URL.createObjectURL(e.target.files[0]),
                    raw: e.target.files[0],
                });
                const datas = new FormData()
                datas.append('image', file)
                datas.append('candidateId', candidateId)
                dispatch(CandidateUpdateProImg(datas));
            }
        }
    }

    const fileInputClicked = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileSizeInBytes = file.size;
            const maxSizeInBytes = 1024 * 1024; // 1MB
            if (fileSizeInBytes > maxSizeInBytes) {
                toast.error('File size exceeds 1MB. Please select a smaller file.');
                e.target.value = null;
            } else {
                // File size is within the limit, you can proceed with the upload
                setFile(file);
            }
        }
    };


    const panCardFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileSizeInBytes = file.size;
            const maxSizeInBytes = 1024 * 1024; // 1MB
            if (fileSizeInBytes > maxSizeInBytes) {
                toast.error('File size exceeds 1MB. Please select a smaller file.');
                e.target.value = null;
            } else {
                // File size is within the limit, you can proceed with the upload
                setPanCardFile(file);
            }
        }
    };


    return (
        <>
            <div>
                <ToastContainer />
                <BootstrapDialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={open}
                >
                    <BootstrapDialogTitle
                        id="customized-dialog-title"
                        onClose={handleClose}
                    >
                        Update Your Profile Details.
                    </BootstrapDialogTitle>
                    <form onSubmit={handleSubmit}>
                        <Box
                            sx={{
                                width: 500,
                                maxWidth: "100%",
                            }}
                        >
                            <TextField
                                fullWidth
                                label="FirstName"
                                value={firstName}
                                name="firstName"
                                onChange={handleInputChange}
                            />
                            <TextField
                                fullWidth
                                label="LastName"
                                value={lastName}
                                name="lastName"
                                onChange={handleInputChange}
                            />
                            <TextField
                                fullWidth
                                label="Position"
                                name="currentDesignation"
                                value={currentDesignation}
                                onChange={handleInputChange}
                            />
                            <TextField
                                fullWidth
                                label="Skills"
                                name="skillList"
                                value={skillList}
                                onChange={handleInputChange}
                            />

                            <div className="passport_container" style={{ width: "100%", display: "flex", margin: "0px 15px", paddingTop: "20px" }}>
                                <div className='gap-4'>
                                    <div className='gap-2'>
                                        <p className='mb-2'>Do you have Passport </p>
                                        
                                        <div className='d-flex gap-3 mb-4'>
                                            <label htmlFor="Yes">Yes</label>
                                            <input type="radio" name="isPassport" id="Yes" onChange={()=> setIsPassport(true)} />
                                            <label htmlFor="No">No</label>
                                            <input type="radio" name="isPassport" id="No" onChange={()=> setIsPassport(false)} />
                                        </div>
                                    </div>


                                    {isPassport &&
                                     <div className='gap-2'>
                                        <p className='mb-2'>Have you traveled abroad ? </p>
                                        
                                        <div className='d-flex gap-3 mb-4'>
                                            <label htmlFor="traveled">Yes</label>
                                            <input type="radio" name="istraveled" id="traveled" onChange={()=> setIsTravelledAbroad(true)} />
                                            <label htmlFor="notTraveled">No</label>
                                            <input type="radio" name="istraveled" id="notTraveled" onChange={()=> setIsTravelledAbroad(false)} />
                                        </div>
                                    </div>}

                                    {/* {
                                     <Box sx={{ margin: "10px 0px 5px 0px", width: "450px" }}>
                                         <FormControl fullWidth>
                                            <InputLabel id="demo-multiple-checkbox-label">Select Countries</InputLabel>
                                            <Select
                                                labelId="demo-multiple-checkbox-label"
                                                id="demo-multiple-checkbox"
                                                multiple
                                                value={travelledCountries}
                                                onChange={handleCountries}
                                                name="jobLocations"
                                                input={<OutlinedInput label="Jobs Locations" />}
                                                renderValue={(selected) => selected.join(', ')}
                                                MenuProps={MenuProps}
                                            >
                                                {countryList.map((name) => (
                                                    <MenuItem key={name} value={name}>
                                                        <Checkbox checked={travelledCountries.indexOf(name) > -1} />
                                                        <ListItemText primary={name} />
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                     </Box>
                                    } */}


                                    {isTravelledAbroad &&
                                     <div className='cand_countries_pro'>
                                         <Box sx={{ margin: "20px 0px 5px 0px", width: "450px" }}>
                                             <FormControl fullWidth>
                                                {/* <InputLabel id="demo-multiple-checkbox-label">Select Countries</InputLabel> */}
                                                <Autocomplete
                                                    multiple
                                                    style={{
                                                        margin: '0px'
                                                    }}
                                                    id="countries-select"
                                                    options={countryList}
                                                    value={travelledCountries}
                                                    onChange={handleCountryChange}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Select Countries"
                                                            placeholder="Search countries..."
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                         </Box>
                                     </div>
                                    }
                                </div>
                            </div>


                            <div style={{ width: "80%", display: "flex", margin: "0px 15px", paddingTop: "20px" }}>
                                <Box sx={{ margin: "3px 0px 5px 0px" }}>
                                    <input
                                        type="file"
                                        name="file"
                                        onChange={handleFileChange}
                                        // accept=".pdf" // Specify the accepted file types
                                        style={{
                                            display: 'none',
                                        }}
                                        id="file-upload"
                                    />
                                    <label htmlFor="file-upload">
                                        <Button
                                            component="span"
                                            variant="outlined"
                                            color="primary"
                                            startIcon={<CloudUploadIcon />}
                                        >
                                            Upload Aadhaar
                                        </Button>
                                    </label>
                                    <span style={{ marginLeft: '10px' }}>
                                        {file ? file.name : 'No file selected'}
                                    </span>
                                </Box>
                            </div>


                            <div style={{ width: "80%", display: "flex", margin: "0px 15px", paddingTop: "10px" }}>
                                <Box sx={{ margin: "3px 0px 5px 0px" }}>
                                    <input
                                        type="file"
                                        name="file"
                                        onChange={panCardFileChange}
                                        style={{
                                            display: 'none',
                                        }}
                                        id="pan-card-upload"
                                    />
                                    <label htmlFor="pan-card-upload">
                                        <Button
                                            component="span"
                                            variant="outlined"
                                            color="primary"
                                            startIcon={<CloudUploadIcon />}
                                        >
                                            Upload PAN Card
                                        </Button>
                                    </label>
                                    <span style={{ marginLeft: '10px' }}>
                                        {panCardFile ? panCardFile.name : 'No file selected'}
                                    </span>
                                </Box>
                            </div>

                        </Box>
                        <DialogActions>
                            <Button autoFocus type="submit" onClick={handleClose}>
                                Save changes
                            </Button>
                        </DialogActions>
                    </form>
                </BootstrapDialog>
            </div>
            <div className="candidate-profile-card cand_main_card" style={{ paddingTop: '1rem' }}>
                <div className="candidate-edit-button" style={{ textAlign: 'left' }}>
                    {location.state === null ? (
                        <div className='d-flex justify-content-between'>
                            <span onClick={handleClickOpen}>
                                {/* <MdEdit /> */}
                                <b>My Profile</b>
                            </span>
                            <span>
                                {/* <MdEdit /> */}
                                <Link to={'/add-candidate-projects'}>
                                    <b>Add Projects</b>
                                </Link>
                            </span>
                        </div>
                    ) : (
                       null
                    )}
                </div>
                <div className="candidate-profile-image">
                    <div style={{ display: "flex" }}>
                        <div>
                            {!profileImg ? <> <img src={userPic} alt="userpic" className='candiproimg' /></> : <img src={profileImg} alt="userpic" className='candiproimg' />}
                        </div>
                        <div style={{ width: "100%" }}>
                            <ProfileDropdown />
                        </div>
                    </div>
                    <span className="AddImageIcons">
                        <BiImageAdd type="file" onClick={fileInputClicked} />
                    </span>
                </div>
                <div className="AddImageIcons">
                    {/* <BiImageAdd type="file"  /> */}
                    <input
                        type="file"
                        className="file-input"
                        ref={fileInputRef}
                        onChange={fileChange}
                    />
                </div>
                <div className="profile-card-header">
                    <div className="candidate-profile-info">
                        {userInfo?.firstName !== null &&
                            userInfo?.firstName !== "" ? (
                            <h5 className="profile-name">
                                {profileData?.firstName ? profileData?.firstName + " " + profileData?.lastName : userInfo?.firstName + " " + userInfo?.lastName}
                            </h5>
                        ) : (
                            <p className="profile-desc candidate_Warning_data">
                                Please Fill Your Name
                            </p>
                        )}
                        {currentDesignation ? (
                            <p className="profile-desc">
                                {currentDesignation}
                            </p>
                        ) : (
                            <p className="profile-desc candidate_Warning_data">
                                Please Fill Your Designation
                            </p>
                        )}
                    </div>
                </div>
                <div className="profile-card-body">
                    <ul className="candidate-status">
                        {skillList ? skillList?.map((item, i) => (
                            // Render each skill here
                            <li key={i}>
                                {item}
                            </li>
                        )) : userInfo?.skillList?.map((item, i) => (
                            // Render each skill here
                            <li key={i}>
                                {item}
                            </li>
                        ))}
                    </ul>
                    <div className="candidate-action">
                        <span className="candidate_last_seen">
                            Last Seen 20 min ago
                        </span>
                    </div>
                    <div className="candidate-star-action">
                        <span class="checked">
                            <FaStar />
                        </span>
                        <span class="checked">
                            <FaStar />
                        </span>
                        <span class="checked">
                            <FaStar />
                        </span>
                        <span class="checked">
                            <FaStar />
                        </span>
                        <span class="checked">
                            <FaStar />
                        </span>
                        <span class="all-reviews">(See All Reviews)</span>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CandidatePro